import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiDelete } from '../api/client.js';

export const useOperationLogs = (filters = {}) =>
  useQuery({
    queryKey: ['operation-logs', filters],
    queryFn: () => apiGet('/operation-logs', { params: filters }),
  });

export const usePurgeOperationLogs = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (olderThanDays) => apiDelete('/operation-logs/purge', { params: { olderThanDays } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['operation-logs'] }),
  });
};
